module.exports = __webpack_public_path__ + "static/strategy.a5d60db7.png";